import React, { Context } from 'react';
import * as IoC from 'typescript-ioc';
import { IModuleVM } from './module-vm';

/**
 * generic factory, which create component, serving as context provider and launching/cleaning up moduleViewModel
 * todo: consider passing props P to the viewmodel (which means root module VM interface must be extended by acceptProps method
 *  and this method to be called when component receive new props
 * @param moduleVMClass - class of the viewmodel, implementing IRootModuleVM interface
 * @param context - context, declared with this viewmodel as type parameter
 * @param RootComponent - root component of the module
 */
const moduleHost = function<T extends IModuleVM, P = {}>(
    moduleVMClass: new (...args) => T,
    context: Context<T>,
    RootComponent: React.ComponentClass<P> | React.FunctionComponent<P>,
    ) {
    return class RootModuleHost extends React.Component<P> {
        private moduleVMInstance: T;

        constructor(props: P, ctx) {
            super(props, ctx);
            this.moduleVMInstance = IoC.Container.get<T>(moduleVMClass);
        }

        public componentDidMount(): void {
            this.moduleVMInstance.didMount();
        }

        public componentWillUnmount(): void {
            this.moduleVMInstance.willUnmount();
        }

        public render() {
            return (
                <context.Provider value={this.moduleVMInstance}>
                    <RootComponent {...this.props} />
                </context.Provider>
            );
        }
    };
};


export { moduleHost };
